import type { LocalStorageState } from './localStorageCodec';

export interface PersistedWidgetState {
    showWorkingTimesInfoBox: boolean;
}

export const localStorageMapper = (input: LocalStorageState): PersistedWidgetState => ({
    showWorkingTimesInfoBox: input.showWorkingTimesInfoBox,
});
